import { render, staticRenderFns } from "./paper-result.vue?vue&type=template&id=60a7528d&scoped=true"
import script from "./paper-result.vue?vue&type=script&lang=js"
export * from "./paper-result.vue?vue&type=script&lang=js"
import style0 from "./paper-result.vue?vue&type=style&index=0&id=60a7528d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a7528d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a7528d')) {
      api.createRecord('60a7528d', component.options)
    } else {
      api.reload('60a7528d', component.options)
    }
    module.hot.accept("./paper-result.vue?vue&type=template&id=60a7528d&scoped=true", function () {
      api.rerender('60a7528d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/paper-result.vue"
export default component.exports